import { LOAN_STATUS, Localization } from 'constant';

export type LoanSummary = {
	total_loan?: number;
	turnaround_time?: number;
	pending_submission?: number;
	resubmission?: number;
	under_verification?: number;
	credit_review?: number;
	pending_investigation?: number;
	pending_review?: number;
	under_evaluation?: number;
	manager_review?: number;
	area_manager_review?: number;
	approved?: number;
	rejected?: number;
	withdrawn?: number;
	disbursed?: number;
	conditional_approval?: number;
	finance_manager_review?: number;
	recalled?: number;
};

export const chartOptionsForMotorace = {
	colors: ['#1EC2F6', '#1E71F6', '#000087'],
	pieSliceText: 'none',
	legend: { position: 'none' },
	backgroundColor: 'transparent',
	Display: 'flex',
	JustifyContent: 'flex-start',
	AllignItems: 'center',
};

export const chartOptionsForCelestina = {
	colors: ['#1B2BA7', '#5665D2', '#9EA5E5'],
	pieSliceText: 'none',
	legend: { position: 'none' },
	backgroundColor: 'transparent',
	Display: 'flex',
	JustifyContent: 'flex-start',
	AllignItems: 'center',
};

export const chartOptionsForWheeltek = {
	colors: [
		"#FFB547",
		"#F69863",
		"#F598D0",
		"#64B6F7",
		"#4BC5AF",
		"#E55667",
		"#7783DB",
		"#BFD8EB",
		"#7BC67E",
	],
	pieSliceText: "none",
	legend: { position: "none" },
	backgroundColor: "transparent",
	Display: "flex",
	JustifyContent: "flex-start",
	AllignItems: "center",
	is3D: false,
};

export const chartOptionsForNewNemar = {
	colors: [
		'#7783DB',
		'#FFB547',
		'#64B6F7',
		'#BFD8EB',
		'#F598D0',
	],
	pieSliceText: 'none',
	legend: { position: 'none' },
	backgroundColor: 'transparent',
	Display: 'flex',
	JustifyContent: 'flex-start',
	AllignItems: 'center',
	pieHole: 0.55,
	is3D: false,
};

export const getChartQtyForMotorace = (loanSummary: LoanSummary) => {
	return [
		['Task', 'Hours per Day'],
		['Pending Submission', loanSummary?.pending_submission],
		['Pending Investigation', loanSummary?.pending_investigation],
		['Pending Review', loanSummary?.pending_review],
	];
};

export const getChartQtyForCelestina = (loanSummary: LoanSummary) => {
	return [
		['Task', 'Hours per Day'],
		['Pending Submission', loanSummary?.pending_submission],
		['Pending Review', loanSummary?.pending_review],
		['Finance Manager Review', loanSummary?.finance_manager_review],
	];
};

export const getChartQtyForWheeltek = (loanSummary: LoanSummary) => {
	return [
		["Task", "Hours per Day"],
		["Pending Submission", loanSummary?.pending_submission],
		["Resubmission", loanSummary?.resubmission],
		["Under Verification", loanSummary?.under_verification],
		["Conditional Approval", loanSummary?.conditional_approval],
		["Credit Review", loanSummary?.credit_review],
		["Pending Investigation", loanSummary?.pending_investigation],
		["Pending Review", loanSummary?.pending_review],
		["Under Evaluation", loanSummary?.under_evaluation],
		["Manager Review", loanSummary?.manager_review],
	];
};

export const getChartQtyForNewNemar = (loanSummary: LoanSummary) => {
	return [
		['Task', 'Hours per Day'],
		['Pending Submission', loanSummary?.pending_submission],
		['Under Verification', loanSummary?.under_verification],
		['Pending Investigation', loanSummary?.pending_investigation],
		['Pending Review', loanSummary?.pending_review],
		['Area Manager Review', loanSummary?.area_manager_review],
	];
};

export const getInnerDisplayFirstRowConfigForMotorace = (
	loanSummary: LoanSummary,
): {
	label: string;
	img: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label: 'Pending Submission',
			img: `${process.env.PUBLIC_URL}/images/submission.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.PENDING_SUBMISSION,
			qty: loanSummary?.pending_submission,
		},
		{
			label: 'Pending Investigation',
			img: `${process.env.PUBLIC_URL}/images/investigation.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.PENDING_INVESTIGATION,
			qty: loanSummary?.pending_investigation,
		},
		{
			label: 'Pending Review',
			img: `${process.env.PUBLIC_URL}/images/review.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.PENDING_REVIEW,
			qty: loanSummary?.pending_review,
		},
	];
};

export const getInnerDisplayFirstRowForWheeltek = (
	loanSummary: LoanSummary,
): {
	label: string;
	img: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label: "Pending Submission".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-submission.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.PENDING_SUBMISSION,
			qty: loanSummary?.pending_submission,
		},
		{
			label: "Resubmission".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-resubmission.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.RESUBMISSION,
			qty: loanSummary?.resubmission,
		},
		{
			label: "Under Verification".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-under-verification.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.UNDER_VERIFICATION,
			qty: loanSummary?.under_verification,
		},
	];
};

export const getInnerDisplaySecondRowForWheeltek = (
	loanSummary: LoanSummary,
): {
	label: string;
	img: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label: "Conditional Approval".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek_conditional_approval.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.CONDITIONAL_APPROVAL,
			qty: loanSummary?.conditional_approval,
		},
		{
			label: "Credit Review".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-credit-review.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.CREDIT_REVIEW,
			qty: loanSummary?.credit_review,
		},
		{
			label: "Pending Investigation".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-pending-investigation.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.PENDING_INVESTIGATION,
			qty: loanSummary?.pending_investigation,
		},
	];
};

export const getInnerDisplayThirdRowForWheeltek = (
	loanSummary: LoanSummary,
): {
	label: string;
	img: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label: "Pending Review".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-pending-review.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.PENDING_REVIEW,
			qty: loanSummary?.pending_review,
		},
		{
			label: "Under Evaluation".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-under-evaluation.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.UNDER_EVALUATION,
			qty: loanSummary?.under_evaluation,
		},
		{
			label: "Manager Review".toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-manager-review.svg`,
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.MANAGER_REVIEW,
			qty: loanSummary?.manager_review,
		},
	];
};

export const getInnerDisplayFirstRowForNewNemar = (
	loanSummary: LoanSummary,
): {
	label: string;
	img: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label: 'Pending Submission'.toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-submission.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.PENDING_SUBMISSION,
			qty: loanSummary?.pending_submission,
		},
		{
			label: 'Under Verification'.toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-under-verification.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.UNDER_VERIFICATION,
			qty: loanSummary?.under_verification,
		},
		{
			label: 'Pending Investigation'.toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-pending-investigation.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.PENDING_INVESTIGATION,
			qty: loanSummary?.pending_investigation,
		},
	];
};

export const getInnerDisplaySecondRowForNewNemar = (
	loanSummary: LoanSummary,
): {
	label: string;
	img: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label: 'Pending Review'.toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-under-evaluation.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.PENDING_REVIEW,
			qty: loanSummary?.pending_review,
		},
		{
			label: 'Area Manager Review'.toUpperCase(),
			img: `${process.env.PUBLIC_URL}/images/wheeltek-pending-review.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.AREA_MANAGER_REVIEW,
			qty: loanSummary?.area_manager_review,
		},
	];
};

export const getOuterDisplayConfig = (
	loanSummary: LoanSummary,
): {
	label: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label:
				Localization.isUsingWheeltekConfig || Localization.isUsingNewNemarConfig
					? "Approved".toUpperCase()
					: "Approved",
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.APPROVED,
			qty: loanSummary?.approved,
		},
		...(Localization.isUsingWheeltekConfig
			? [
					{
						label: "Recalled".toUpperCase(),
						pathname: "/loan-list",
						applicationstatus: LOAN_STATUS.RECALLED,
						qty: loanSummary?.recalled,
					},
			  ]
			: []),
		{
			label:
				Localization.isUsingWheeltekConfig || Localization.isUsingNewNemarConfig
					? "Disapproved".toUpperCase()
					: "Rejected",
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.REJECTED,
			qty: loanSummary?.rejected,
		},
		{
			label:
				Localization.isUsingWheeltekConfig || Localization.isUsingNewNemarConfig
					? "Disbursed".toUpperCase()
					: "Disbursed",
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.DISBURSED,
			qty: loanSummary?.disbursed,
		},
		{
			label:
				Localization.isUsingWheeltekConfig || Localization.isUsingNewNemarConfig
					? "Withdrawn".toUpperCase()
					: "Withdrawn",
			pathname: "/loan-list",
			applicationstatus: LOAN_STATUS.WITHDRAWN,
			qty: loanSummary?.withdrawn,
		},
	];
};

export const getInnerDisplayFirstRowConfigForCelestina = (
	loanSummary: LoanSummary,
): {
	label: string;
	img: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label: 'Pending Submission',
			img: `${process.env.PUBLIC_URL}/images/celestina_pending_submission.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.PENDING_SUBMISSION,
			qty: loanSummary?.pending_submission,
		},
		{
			label: 'Pending Review',
			img: `${process.env.PUBLIC_URL}/images/celestina_pending_review.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.PENDING_REVIEW,
			qty: loanSummary?.pending_review,
		},
		{
			label: 'Finance Manager Review',
			img: `${process.env.PUBLIC_URL}/images/celestina_finance_manager_review.svg`,
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.FINANCE_MANAGER_REVIEW,
			qty: loanSummary?.finance_manager_review,
		},
	];
};

export const getOuterDisplayConfigForCelestina = (
	loanSummary: LoanSummary,
): {
	label: string;
	pathname: string;
	applicationstatus: string;
	qty: number;
}[] => {
	return [
		{
			label:'Approved'.toUpperCase(),
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.APPROVED,
			qty: loanSummary?.approved,
		},
		{
			label: 'Disapproved'.toUpperCase(),
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.REJECTED,
			qty: loanSummary?.rejected,
		},
		{
			label: 'Disbursed'.toUpperCase(),
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.DISBURSED,
			qty: loanSummary?.disbursed,
		},
		{
			label:'Withdrawn'.toUpperCase(),
			pathname: '/loan-list',
			applicationstatus: LOAN_STATUS.WITHDRAWN,
			qty: loanSummary?.withdrawn,
		},
	];
};

export const displayTurnaroundTime = (durationInSeconds: number) => {
	const days = Math.floor(durationInSeconds / 86400);
	let remaining = durationInSeconds % 86400;
	const hours = Math.floor(remaining / 3600);
	remaining = remaining % 3600;
	const minutes = Math.floor(remaining / 60);
	return `${days} days, ${hours} hours, ${minutes} minutes`;
};